import styled from 'styled-components'

// Container for NotFound component
export const NotFoundContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background-color: ${props => (props.isDarkTheme ? '#181818' : '#f9f9f9')};
`

// Image for the NotFound page
export const Image = styled.img`
  width: 300px;
  margin-bottom: 20px;
`

// Heading style, using dynamic color based on theme
export const Heading = styled.h1`
  font-size: 28px;
  color: ${props => (props.isDarkTheme ? '#ffffff' : '#000000')};
  text-align: center;
  margin-bottom: 10px;
`

// Description text for the NotFound page
export const Desc = styled.p`
  font-size: 18px;
  color: ${props => (props.isDarkTheme ? '#cccccc' : '#1e293b')};
  text-align: center;
  max-width: 400px;
`
